import Vue from 'vue';

// import "vuetify/dist/vuetify.min.css";
import 'vuetify/src/stylus/main.styl';
import Vuetify from 'vuetify/lib';
import '@mdi/font/css/materialdesignicons.css';

Vue.use(Vuetify, {
  iconfont: 'mdi',
  theme: {
    primary: `${process.env.PRIMARYCOLOR}`,
    secondary: '#00c2f3',
    accent: '#7986CB',
    error: '#f44336',
    warning: '#44d9ff',
    info: '#2196f3',
    success: '#4caf50',
  },
});
